export const GalaxyChartPredefinedColor = {
  BLUE: {
    SOLID: 'rgb(66, 165, 245)',
    GRADIENT: [
      'rgba(66, 165, 245, 0.5)',
      'rgba(66, 165, 245, 0.3)',
      'rgba(66, 165, 245, 0.2)',
      'rgba(66, 165, 245, 0.0)',
      'rgba(66, 165, 245, 0.0)',
    ],
  },
};
